export default {
  path: '/',
  name: 'symbols',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: 'symbols-cjdx',
      name: 'symbols-cjdx',
      meta: { title: '股票池管理', permission: 'symbols' },
      component: () => import('@/views/symbols/Symbols'),
    },
    {
      path: 'symbols-yzqmx',
      name: 'symbols-yzqmx',
      meta: { title: '股票池管理', permission: 'symbols' },
      component: () => import('@/views/symbols/yzqmx'),
    },
    {
      path: 'symbols-smqmx',
      name: 'symbols-smqmx',
      meta: { title: '股票池管理', permission: 'symbols' },
      component: () => import('@/views/symbols/sm'),
    },
  ],
}